import { Component, OnInit } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { AngularDraggableModule } from "angular2-draggable";
import { DeviceHelper } from "../../../gyzmo-commons/helpers/device.helper";
import { MemoryUsagePlugin } from "../../../plugins/memory-usage/memoryUsagePlugin";

@Component({
    selector: "app-memory-usage-div",
    templateUrl: "memory-usage-div.component.html",
    styleUrls: ["memory-usage-div.component.scss"],
    imports: [AngularDraggableModule, IonicModule],
})
export class MemoryUsageDivComponent implements OnInit {
    visible = true;
    memoryUsage: string = "";

    constructor(private deviceHelper: DeviceHelper) {
    }

    ngOnInit() {
        setInterval(() => {
            void this.updateMemoryUsage();
        }, 500);
        void this.updateMemoryUsage();
    }

    logComprehensiveMemoryUsage(memoryInfo: any) {
        let result = "Native :\n";
        // Logger les informations via ActivityManager
        result += "ActivityManager (App / System constraints) (5min refresh):" + "\n";
        for (const key in memoryInfo.activityManager) {
            result += `- ${ key } : ${ memoryInfo.activityManager[key].toFixed(2) } MB` + "\n";
        }
        result += "\n";

        // Logger les informations via Runtime
        result += "Runtime (App / JVM):" + "\n";
        for (const key in memoryInfo.runtime) {
            result += `- ${ key } : ${ memoryInfo.runtime[key].toFixed(2) } MB` + "\n";
        }
        result += "\n";

        // Logger les informations de /proc/meminfo
        result += "/proc/meminfo (Device) :" + "\n";
        for (const key of Object.keys(memoryInfo.meminfo).sort()) {
            result += `- ${ key } : ${ memoryInfo.meminfo[key].toFixed(2) } MB` + "\n";
        }
        result += "\n";

        return result;
    }

    /**
     * Formate les octets en mégaoctets (Mo).
     * @param bytes Nombre d'octets
     * @returns Valeur en Mo
     */
    private formatBytes(bytes: number): number {
        return bytes / 1024 / 1024;
    }

    private getWebViewMemoryUsage() {
        // Vérifier si l'API PerformanceMemory est disponible
        if ("memory" in performance) {
            const memory = (performance as any).memory;
            if (memory) {
                return `WebView : \n${ this.formatBytes(memory.usedJSHeapSize).toFixed(2) } / ${ this.formatBytes(memory.jsHeapSizeLimit).toFixed(2) } MB\n`;
            }
        }

        throw new Error("API PerformanceMemory non disponible");
    }

    private async updateMemoryUsage() {
        let memoryUsageText = "";
        try {
            memoryUsageText += this.getWebViewMemoryUsage();
        } catch {
            memoryUsageText = `WebView : \nNo data\n`;
        }

        if (this.deviceHelper.isRunningOnDevice()) {
            memoryUsageText += "\n";
            try {
                let memoryUsage = await MemoryUsagePlugin.getComprehensiveMemoryInfo();
                memoryUsageText += this.logComprehensiveMemoryUsage(memoryUsage);
            } catch {
                // Ignore
            }
        }

        this.memoryUsage = memoryUsageText;
    }
}
